// extracted by mini-css-extract-plugin
export default {"full-width":"Field_full-width__IcJ0j","half-width":"Field_half-width__edF5Q","medium":"Field_medium__Tsspl","small":"Field_small__RWdGh","field-caption":"Field_field-caption__6ToAM"};